import Vue from "vue";
import Router from "vue-router";
import store from "@/store";
import config from "@/config";
import bus from "@/bus";
import { DO_ROUTE } from "@/config/constants/action-types";

Vue.use(Router);

const router = new Router({
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

/* Con esto actualizo el store con el paso actual para que los watchers lo sepan */
router.beforeEach((to, from, next) => {
  const forcedRouteName = "mensaje";
  const forcedMessageCode = "no-disponible";
  const messageCode = (to.params || {}).mje;
  const mustRedirect =
    to.name !== forcedRouteName || messageCode !== forcedMessageCode;

  if (mustRedirect) {
    return next({
      name: forcedRouteName,
      params: { mje: forcedMessageCode },
      replace: true
    });
  }

  to.meta.config = config.getPasoProperties(to.name);
  to.meta.name = to.name;
  store.dispatch(DO_ROUTE, { from, ...to });
  bus.$emit("analytics:event", {
    event: "route_change",
    eventData: { from, to }
  });
  next();
});

export default router;
